export function getExpirationDate(accountData: any) {
	return hasAccountData(accountData) ? accountData.validUntil : "-";
}

export function hasAccountData(accountData) {
	return Boolean(accountData);
}
